export enum ECPDActions {
  CHANGE_MODAL_TYPE = 'cpd/changeModalType',
  SET_CPD_PIK_LANDING_CHANNEL = 'cpd/setCpdPikLandingChannel',
  SET_CPD_DEAL_TYPE = 'cpd/setCpdDealType',
  SET_CPD_DRAFT_SOURCE = 'cpd/setCpdDraftSource',
  SET_CPD_DRAFT_ID = 'cpd/setCpdDraftId',
  SET_CPD_DRAFT_STATUS = 'cpd/setCpdDraftStatus',
  SET_CPD_CHAT_ID_LOADING_STATUS = 'cpd/setCpdChatIdLoadingStatus',
}
